export const data = {
  loading: 'Cargando datos…',
  loadError: 'No se pudieron cargar los datos.',
  rangeEmpty: {
    title: 'No hay datos para mostrar',
    hint: 'Probá con un rango de fechas más amplio.',
    reset: 'Ver último análisis',
  },
  runRange: {
    ariaLabel: 'Seleccionar rango de fechas',
    label: 'Rango de fechas',
    presets: {
      latest: 'Último análisis',
      allTime: 'Todo el historial',
    },
  },
  export: {
    button: 'Descargar',
    ariaLabel: 'Descargar la data del análisis o rango seleccionado',
    files: {
      prompts: 'prompts',
      responses: 'respuestas',
      sourceDomains: 'fuentes-dominios',
      sourcePages: 'fuentes-paginas',
      overview: 'resumen',
    },
    values: {
      yes: 'Sí',
      no: 'No',
      competitor: 'Competidor',
      thirdParty: 'Tercero',
    },
    columns: {
      prompt: 'Prompt',
      topic: 'Tópico',
      tags: 'Tags',
      status: 'Estado',
      mentionGap: 'Gap de mención',
      mentionPercent: '% Mención',
      competitorMentionPercent: '% Mención competidores',
      citationGap: 'Gap de citación',
      citationPercent: '% Citación',
      competitorCitationPercent: '% Citación competidores',
      sentimentPercent: '% Sentimiento',
      avgPosition: 'Posición promedio',
      mentionChange: 'Cambio de mención',
      sentimentChange: 'Cambio de sentimiento',
      impressions: 'Impresiones',
      competition: 'Competencia',
      monthlySearches: 'Búsquedas mensuales',
      totalValue: 'Valor total',
      estimatedValueCaptured: 'Valor estimado capturado',
      language: 'Idioma',
      personas: 'Personas',
      totalResponses: 'Respuestas totales',
      createdAt: 'Creado',
      date: 'Fecha',
      monthlyQueries: 'Búsquedas mensuales',
      model: 'Modelo',
      promptType: 'Tipo de prompt',
      basePrompt: 'Prompt base',
      promptVariation: 'Variación del prompt',
      response: 'Respuesta',
      mentioned: 'Mencionado',
      marketPosition: 'Posición de mercado',
      sentiment: 'Sentimiento',
      competitorsMentioned: 'Competidores mencionados',
      sources: 'Fuentes',
      cited: 'Citado',
      attributedCitation: 'Citación atribuida',
      persona: 'Persona',
      country: 'País',
      location: 'Ubicación',
      rank: 'Rank',
      domain: 'Dominio',
      type: 'Tipo',
      responsesInfluenced: 'Respuestas influenciadas',
      urls: 'URLs',
      impressionsCaptured: 'Impresiones capturadas',
      pageUrl: 'URL',
      rootDomain: 'Dominio raíz',
      citations: 'Citaciones',
      sourceTags: 'Tags de fuente',
    },
    overview: {
      sections: {
        kpis: 'KPIs',
        shareOfVoice: 'Share of Voice',
        shareOfVoiceByModel: 'Share of Voice por modelo',
        mentionRate: 'Tasa de mención (por período)',
        citationRate: 'Tasa de citación (por período)',
        heatmapMention: 'Heatmap — Mención (%)',
        heatmapCitation: 'Heatmap — Citación (%)',
        brandTraitsPositive: 'Atributos de marca — Positivos',
        brandTraitsNegative: 'Atributos de marca — Negativos',
      },
      columns: {
        metric: 'Métrica',
        value: 'Valor',
        competitor: 'Competidor',
        domain: 'Dominio',
        sovPercent: 'SoV %',
        mentions: 'Menciones',
        model: 'Modelo',
        period: 'Período',
        brandPercent: 'Marca %',
        competitorsPercent: 'Competidores %',
        topic: 'Tópico',
        trait: 'Atributo',
        traitBrandPercent: 'Marca %',
        traitCompetitorPercent: 'Competidor %',
      },
    },
  },
  dashboard: {
    title: 'Dashboard de Datos',
    filters: {
      addFilter: 'Agregar filtro',
      clearAll: 'Limpiar todo',
      models: 'Modelos',
      isAnyOf: 'es cualquiera de',
      selected: 'seleccionados',
      searchFields: 'Buscar campos...',
      searchModels: 'Buscar modelos...',
      selectAll: 'Seleccionar todos',
      noData: 'Sin datos',
      removeFilter: 'Remover filtro',
      topicsAndPrompts: 'Temas y Prompts',
      promptTags: 'Etiquetas de Prompts',
      searchTopics: 'Buscar temas y prompts...',
      searchTags: 'Buscar etiquetas...',
      prompts: 'Prompts',
      competitors: 'Competidores',
      searchCompetitors: 'Buscar competidores...',
    },
    kpis: {
      responsesAnalyzed: 'Respuestas Analizadas',
      sourcesTracked: 'Fuentes Monitoreadas',
    },
    shareOfVoice: {
      title: 'Share of Voice',
      subtitle: 'Visibilidad de la marca y competidores en las respuestas monitoreadas.',
      tooltip: {
        shareLabel: 'Participación',
        mentionsLabel: 'Menciones',
      },
    },
    shareOfVoiceByModel: {
      title: 'Share of Voice por Modelo',
      subtitle: 'Visibilidad distribuida entre modelos de IA y superficies de respuesta.',
      tooltip: {
        shareLabel: 'Participación',
        mentionsLabel: 'Menciones',
      },
    },
    mentionRate: {
      title: 'Tasa de Mención Relativa',
      subtitle: 'Tasa de mención de la marca frente a competidores en respuestas relevantes.',
      averageLabel: 'promedio de tasa de mención',
      detailedCaption: '{{mentions}} menciones en {{responses}} respuestas relevantes',
    },
    absoluteMentionRate: {
      title: 'Tasa de Mención Absoluta',
      subtitle: 'Tasa de mención de la marca sobre el total de respuestas analizadas.',
      detailedCaption: '{{mentions}} menciones en {{responses}} respuestas',
    },
    citationRate: {
      title: 'Tasa de Citación',
      subtitle: 'Porcentaje de respuestas que citan la marca frente a competidores.',
      averageLabel: 'promedio de tasa de citación',
      detailedCaption: '{{citations}} citaciones · {{responses}} respuestas',
    },
    competitorHeatmap: {
      title: 'Mapa de Calor de Competidores',
      subtitle: 'Visibilidad por tópico y competidor en menciones y citaciones.',
      metric: {
        mention: 'Mención',
        citation: 'Citación',
      },
    },
    positiveTraits: {
      title: 'Atributos Positivos',
      subtitle: 'Frecuencia con la que la marca se asocia a atributos positivos.',
    },
    negativeTraits: {
      title: 'Atributos Negativos',
      subtitle: 'Frecuencia con la que la marca se asocia a atributos negativos.',
    },
    traitsView: {
      radar: 'Radar',
      trend: 'Tendencia',
    },
    traitsLegend: {
      competitors: 'Competidores',
    },
    legend: {
      competitor: 'Competidor',
    },
    showRelative: 'Ver Relativo',
    showAbsolute: 'Ver Absoluto',
    toggle: {
      detailed: 'Detallado',
      simple: 'Simple',
    },
    traitsTable: {
      trait: 'Atributo',
      you: 'Tú',
      comp: 'Comp',
    },
    traitNames: {
      dianCompliance: 'Cumplimiento DIAN',
      latinFocus: 'Enfoque LatAm',
      mobileManagement: 'Gestión Móvil',
      assetTracking: 'Control de Activos',
      financialSimplicity: 'Simplicidad Financiera',
      manualFocus: 'Enfoque Manual',
      manualRecords: 'Registros Manuales',
      socialSelling: 'Venta por Redes',
      agile: 'Ágil',
      collaborative: 'Colaborativo',
      customerCentric: 'Centrado en el Cliente',
      dataDriven: 'Basado en Datos',
      efficient: 'Eficiente',
      outcomeOriented: 'Orientado a Resultados',
      scalable: 'Escalable',
      strategic: 'Estratégico',
      trusted: 'Confiable',
      bureaucratic: 'Burocrático',
      overpromising: 'Promesas Excesivas',
      priceDriven: 'Centrado en Precio',
      reactive: 'Reactivo',
      riskAverse: 'Averso al Riesgo',
      highQuality: 'Alta Calidad',
      innovative: 'Innovador',
      goodDisplay: 'Buena Pantalla',
      featureRich: 'Muchas Funciones',
      premiumDesign: 'Diseño Premium',
      wideRange: 'Amplia Variedad',
      smartFeatures: 'Funciones Inteligentes',
      reliable: 'Confiable',
      goodForSports: 'Bueno para Deportes',
      energyEfficient: 'Eficiencia Energética',
      expensive: 'Caro',
      complexSetup: 'Configuración Compleja',
      bloatware: 'Bloatware',
      premiumOnly: 'Solo Premium',
      shortUpdates: 'Actualizaciones Cortas',
      fragileScreen: 'Pantalla Frágil',
      slowSupport: 'Soporte Lento',
      heavy: 'Pesado',
      overkill: 'Funciones Excesivas',
      limitedBudget: 'Opciones Económicas Limitadas',
      accurate: 'Preciso',
      affordable: 'Accesible',
      extensive: 'Amplio',
      fast: 'Rápido',
      localized: 'Localizado',
      multiSource: 'Multi-Fuente',
      transparent: 'Transparente',
      versatile: 'Versátil',
      complex: 'Complejo',
      fragmented: 'Fragmentado',
      inaccurate: 'Impreciso',
      inconsistent: 'Inconsistente',
      limited: 'Limitado',
      opaque: 'Opaco',
      slow: 'Lento',
      unreliable: 'Poco Confiable',
      unresponsive: 'Sin Respuesta',
      outdated: 'Desactualizado',
      aiAppliedToHr: 'IA aplicada a HR',
      integratedPlatform: 'Plataforma integrada',
      argentineCompliance: 'Cumplimiento normativo argentino',
      localSupport: 'Soporte local',
      enterpriseSecurity: 'Seguridad enterprise',
      implementationSpeed: 'Velocidad de implementación',
      functionalDepth: 'Profundidad funcional',
      provenScale: 'Escala probada',
      vismaWayConfusion: 'Confusión Visma Way',
      enterpriseOnly: 'Solo para empresas grandes',
      slowImplementation: 'Implementación lenta',
      rigidProduct: 'Producto rígido',
      legacyInterface: 'Interfaz anticuada',
      mobileLackingFocus: 'Enfoque mobile limitado',
      bureaucraticSupport: 'Soporte burocrático',
      freemiumVersion: 'Versión gratuita / freemium',
      simpleOperation: 'Operación simple / fácil de usar',
      mobileFirst: 'App móvil / mobile-first',
      closeHumanSupport: 'Soporte humano cercano',
      latamCoverage: 'Cobertura LatAm / multipaís',
      industryVerticals: 'Verticales por rubro',
      allInOnePlatform: 'Todo-en-uno / integral',
      financialInclusion: 'Inclusión financiera / emprendedores',
      technicalBugs: 'Bugs / fricción técnica',
      barcodeScanIssues: 'Lector de códigos con problemas',
      freeTierLimits: 'Limitaciones plan gratuito',
      limitedEInvoicing: 'Facturación electrónica limitada',
      lackOfIntegrations: 'Falta de integraciones / ERP',
      notForLargeBusiness: 'No apto para negocios grandes',
      learningCurve: 'Curva de aprendizaje',
      fintechSpecialization: 'Especialización en fintech',
      flutterExpertise: 'Expertise en Flutter',
      nicheFocus: 'Enfoque de nicho',
      uiUxFocus: 'Enfoque en UI/UX',
      budgetFocus: 'Enfoque en presupuesto',
      codeQuality: 'Calidad de código',
      crossPlatformConcerns: 'Dudas sobre cross-platform',
      nearshorePresence: 'Presencia nearshore',
    },
  },
  prompts: {
    title: 'Prompts',
    description:
      'Análisis de los prompts agrupados por tema, resúmenes y métricas de respuestas.',
    filters: {
      trigger: 'Filtros',
      search: 'Buscar prompts',
      status: 'Estado',
      topic: 'Tema',
      tag: 'Etiqueta',
      language: 'Idioma',
      competition: 'Competencia',
      all: 'Todos',
      clearFilters: 'Limpiar filtros',
      dateFrom: 'Desde',
      dateTo: 'Hasta',
      dateRange: 'Rango de fechas',
      applyFilters: 'Aplicar filtros',
    },
    columns: {
      prompt: 'Prompt',
      topic: 'Tema',
      tags: 'Etiquetas',
      status: 'Estado',
      mentionPercent: 'Mención %',
      mentionGap: 'Brecha de Mención',
      competitorMentionPercent: 'Mención Competidor %',
      citationPercent: 'Citación %',
      citationGap: 'Brecha de Citación',
      competitorCitationPercent: 'Citación Competidor %',
      sentimentPercent: 'Sentimiento %',
      avgPosition: 'Posición Prom.',
      mentionChange: 'Cambio de Mención',
      sentimentChange: 'Cambio de Sentimiento',
      impressions: 'Impresiones',
      competition: 'Competencia',
      monthlySearches: 'Búsquedas Mensuales',
      totalValue: 'Valor Total',
      estimatedValueCaptured: 'Valor Estimado Capturado',
      language: 'Idioma',
      personas: 'Personas',
      totalResponses: 'Respuestas Totales',
      createdAt: 'Fecha de Creación',
    },
    actions: {
      viewResponses: 'Ver respuestas',
      dateRange: 'Rango de Fechas',
      views: 'Vistas',
      addMore: 'Agregar Más',
      openMenu: 'Abrir menú de acciones',
      selectVisible: 'Seleccionar prompts visibles',
    },
    ui: {
      total: 'Total:',
      noMatchingPrompts: 'No hay prompts que coincidan con los filtros seleccionados.',
      showingCount: 'Mostrando {{visible}} de {{total}} prompts (y {{variations}} variaciones)',
      comparedTo: 'comparado con',
      selectPeriod: 'Seleccionar período...',
      loading: 'Cargando prompts...',
      error: 'Error al cargar prompts. Intenta de nuevo.',
    },
    drawer: {
      metrics: {
        responsesAnalyzed: 'Respuestas Analizadas',
        sourcesTracked: 'Fuentes Monitoreadas',
        attributedCitations: 'Citaciones Atribuidas',
      },
      charts: {
        shareOfVoice: 'Share of Voice',
        shareOfVoiceDesc: 'Cuán seguido la IA menciona tu marca vs competidores',
        shareOfVoiceByModel: 'Cuota de Voz por Modelo',
        shareOfVoiceByModelDesc: 'Visibilidad de tu marca en cada modelo de IA',
        mentionRate: 'Tasa de Mención',
        mentionRateDesc: 'Tu proporción de menciones en respuestas relevantes',
        mentionRateAverage: 'Promedio de mención',
        citationRate: 'Tasa de Citación',
        citationRateDesc: 'Cuán seguido la IA cita tu contenido',
        citationRateAverage: 'Promedio de citación',
        positionOverTime: 'Posición en el Tiempo',
        positionOverTimeDesc: 'Seguimiento de tu ranking en respuestas de IA',
        dailyShareOfVoice: 'Cuota de Voz Diaria',
        dailyShareOfVoiceDesc: 'Tendencia diaria de Share of Voice',
        noData: 'Sin datos',
        averagePosition: 'posición promedio',
      },
      variations: {
        title: 'Variaciones del Prompt',
        total: '{{count}} total',
        columns: {
          type: 'Tipo',
          text: 'Texto del prompt',
        },
        types: {
          base: 'Prompt Base',
          variation: 'Variación',
        },
      },
      actions: {
        expand: 'Expandir panel',
        close: 'Cerrar',
      },
    },
  },
  responses: {
    title: 'Respuestas',
    description:
      'Visibilidad de respuestas con navegación vinculada desde prompts y filtros funcionales por modelo, citación y presencia de fuentes.',
    filters: {
      trigger: 'Filtros',
      search: 'Buscar respuesta',
      prompt: 'Temas y Prompts',
      promptType: 'Tipo de Prompt',
      model: 'Modelo',
      mentioned: 'Mencionado',
      cited: 'Citado',
      attributedCitation: 'Citación Atribuida',
      all: 'Todos',
      allPrompts: 'Todos los prompts',
      allPromptTypes: 'Todos los tipos',
      allModels: 'Todos los modelos',
      clearFilters: 'Limpiar filtros',
      applyFilters: 'Aplicar filtros',
      dateFrom: 'Desde',
      dateTo: 'Hasta',
      dateRange: 'Rango de fechas',
      yes: 'Sí',
      no: 'No',
    },
    columns: {
      date: 'Fecha',
      model: 'Modelo',
      mentioned: 'Mencionado',
      competitorsMentioned: 'Competidores Mencionados',
      sources: 'Fuentes',
      cited: 'Citado',
      attributedCitation: 'Citación Atribuida',
      promptType: 'Tipo de Prompt',
      basePrompt: 'Prompt',
      promptVariation: 'Variación de Prompt',
      country: 'País',
      response: 'Respuesta',
    },
    actions: {
      views: 'Vistas',
    },
    drawer: {
      title: 'Detalle de respuesta',
      promptAndResponse: 'Prompt y Respuesta',
      basePrompt: 'Prompt Base',
      competitors: 'Competidores Mencionados',
      sources: 'Fuentes',
      fullResponse: 'Respuesta',
      noSources: 'Sin fuentes',
    },
    ui: {
      total: 'Total:',
      filteredPromptLabel: 'Prompt',
      showingCount: 'Mostrando {{visible}} de {{total}} respuestas',
      loading: 'Cargando respuestas...',
      error: 'Error al cargar respuestas. Intenta de nuevo.',
      noMatchingResponses:
        'No hay respuestas que coincidan con los filtros seleccionados.',
      loadMore: 'Cargar Más',
      entireExportLoaded: 'Export completo cargado',
      filteredFromResponses: 'Filtrado de {{total}} respuestas totales',
    },
  },
  sources: {
    title: 'Fuentes de Datos',
    description:
      'Análisis de fuentes con dominios ordenables, tipos de fuente y métricas de influencia.',
    modes: {
      domain: 'Dominio',
      page: 'Página',
      all: 'Todos',
      social: 'Social',
    },
    social: {
      all: 'Todos',
      less: 'Menos',
      more: 'Más',
      noData: 'Sin datos para los filtros actuales',
    },
    filters: {
      type: 'Tipo',
      mentioned: 'Mencionado',
      minCitation: 'Citación mín %',
      minResponses: 'Respuestas mín',
      all: 'Todos',
      thirdParty: 'Tercero',
      competitor: 'Competidor',
      yes: 'Sí',
      no: 'No',
      clearFilters: 'Limpiar filtros',
      dateFrom: 'Desde',
      dateTo: 'Hasta',
      dateRange: 'Rango de fechas',
      applyFilters: 'Aplicar filtros',
    },
    columns: {
      rank: '#',
      domain: 'Dominio',
      page: 'Página',
      sparkchart: 'Sparkline',
      type: 'Tipo',
      citationPercent: 'Citación %',
      citations: 'Citaciones',
      responsesInfluenced: 'Respuestas Influenciadas',
      impressionsCaptured: 'Impresiones Captadas',
      brandMentionPercent: 'Mención de marca %',
      competitorMentionPercent: 'Mención de competidor %',
      urls: 'URLs',
    },
    ui: {
      dateRange: 'Rango de Fechas',
      searchDomains: 'Buscar dominios',
      searchUrls: 'Buscar URLs',
      tags: 'Etiquetas',
      views: 'Vistas',
      showingCountDomains: 'Mostrando {{displayed}} de {{total}} Dominios',
      showingCountPages: 'Mostrando {{displayed}} de {{total}} URLs',
      updatingFilters: 'Actualizando filtros...',
      loadMore: 'Cargar Más',
      entireExportLoaded: 'Exportación completa cargada',
      filteredFromDomains: 'Filtrado de {{total}} dominios totales',
      filteredFromPages: 'Filtrado de {{total}} URLs totales',
      noMatchingSources: 'No hay fuentes que coincidan con los filtros seleccionados.',
      error: 'Error al cargar fuentes. Intenta de nuevo.',
      filteredByPrompt: 'Filtrado por prompt:',
      clearPromptFilter: 'Quitar filtro de prompt',
      urlsTooltip: '{{count}} URLs únicas indexadas para {{domain}}',
    },
    analytics: {
      trigger: 'Ver analítica',
      title: 'Analítica',
      subtitle: 'Desglose de citaciones para {{domain}}.',
      close: 'Cerrar panel de analítica',
      citationRateTitle: 'Tasa de Citación en el Tiempo',
      citationRateDescription:
        'Porcentaje de respuestas que citan esta fuente en el tiempo.',
      urlBreakdown: 'Desglose por URL',
      promptBreakdown: 'Desglose por Prompt',
      empty: 'Sin datos para los filtros actuales.',
      showingUrls: 'Mostrando {{count}} de {{total}} URLs',
      showingPrompts: 'Mostrando {{count}} de {{total}} prompts',
      columns: {
        url: 'URL',
        prompt: 'Prompt',
        mentioned: 'Mencionado',
        competitors: 'Competidores Mencionados',
        firstSeen: 'Primer Registro',
        citationPercent: 'Citación %',
        domainPercent: 'Dominio %',
        citations: 'Citaciones',
      },
      filters: {
        dateRange: 'Rango de Fechas',
        topicsPrompts: 'Temas y Prompts',
        mentioned: 'Mencionado',
        cited: 'Citado',
        model: 'Modelo',
        addFilter: 'Agregar filtro',
        clearAll: 'Limpiar todo',
        apply: 'Aplicar',
        reset: 'Reiniciar',
        selectPlaceholder: 'Seleccionar...',
        searchPromptsPlaceholder: 'Buscar prompts...',
        noPromptsMatch: 'Ningún prompt coincide con tu búsqueda.',
        countSelected: '{{count}} seleccionado(s)',
        operatorIs: 'es',
        operatorIsAnyOf: 'es cualquiera de',
        optionAny: 'Cualquiera',
        optionYes: 'Sí',
        optionNo: 'No',
        removeFilter: 'Quitar filtro',
        clearShort: 'Limpiar',
      },
    },
  },
  placeholder: {
    badge: 'Vista previa',
    status: 'Esta sección está disponible solo para {{brand}} por ahora.',
    cardTitle: 'Próximamente',
    cardDescription:
      'La base de este módulo ya está lista. La próxima iteración podrá conectar datos, prompts y fuentes reales.',
  },
  actions: {
    title: 'Acciones',
    tabs: {
      content: 'Oportunidades de contenido',
      forums: 'Hilos en foros',
      gaps: 'Brechas de topics',
    },
    priority: {
      high: 'Alta',
      medium: 'Media',
      low: 'Baja',
    },
    filters: {
      all: 'Todos',
      allPriorities: 'Todas',
      allPlatforms: 'Todas',
      allThreads: 'Todos los hilos',
    },
    content: {
      count: '{{visible}} de {{total}} oportunidades',
      empty: 'Ninguna oportunidad coincide con los filtros.',
      columns: {
        opportunity: 'Oportunidad',
        source: 'Fuente',
        priority: 'Prioridad',
        citations: 'Citas',
        responses: 'Respuestas',
        topic: 'Topic',
        action: 'Acción sugerida',
      },
      source: {
        competitor: 'Competidor',
        thirdParty: 'Tercero',
      },
      action: {
        create_better_content: 'Crear mejor contenido',
        pitch_guest_post: 'Pitch de guest post',
        outreach_mention: 'Pedir mención',
      },
    },
    forums: {
      count: '{{visible}} de {{total}} hilos',
      empty: 'Ningún hilo coincide con los filtros.',
      brandMentionedShort: 'Mencionado',
      brandMissingShort: 'No mencionado',
      columns: {
        thread: 'Hilo',
        priority: 'Prioridad',
        brand: '{{brand}}',
        responses: 'Respuestas',
        engagement: 'Engagement',
        lastActivity: 'Actividad',
        action: 'Acción sugerida',
      },
      platform: {
        reddit: 'Reddit',
        mercadolibre_qa: 'Mercado Libre Q&A',
        taringa: 'Taringa',
        forocoches: 'ForoCoches',
        stackexchange: 'Stack Exchange',
        elhacker: 'ElHacker',
      },
      action: {
        reply_thread: 'Responder hilo',
        create_thread: 'Crear hilo',
        monitor_thread: 'Monitorear',
      },
    },
    gaps: {
      count: '{{visible}} de {{total}} brechas',
      empty: 'Ninguna brecha coincide con los filtros.',
      totalArticles: '{{value}} artículos sugeridos',
      columns: {
        topic: 'Topic',
        priority: 'Prioridad',
        brand: '{{brand}}',
        competitor: 'Mejor competidor',
        gap: 'Brecha',
        searches: 'Búsquedas / mes',
        articles: 'Artículos',
      },
      sort: {
        gap: 'Mayor brecha',
        searches: 'Más búsquedas',
      },
    },
    geo: {
      tabs: {
        editorial: 'Editorial',
        forums: 'Foros',
        external: 'Activos externos',
        listings: 'Listings & reviews',
        content: 'Oportunidades de contenido',
      },
      common: {
        empty: 'Ninguna fila coincide con los filtros.',
        searchPlaceholder: 'Buscar…',
        visibleCount: '{{visible}} de {{total}}',
        loadMore: 'Cargar más',
        filterAll: 'Todos',
        filterMentioned: 'Mencionan a {{brand}}',
        filterNotMentioned: 'No mencionan',
        mentionedYes: 'Te menciona',
        mentionedNo: 'No te menciona',
        cols: {
          citations: 'Citas',
          impressions: 'Impresiones',
          mentions: '¿Te menciona?',
          competitors: 'Competidores citados',
          action: 'Acción sugerida',
        },
      },
      editorial: {
        intro:
          'Fuentes editoriales citadas en respuestas — medios de prensa y enciclopedias. Auditá la cobertura y gestioná PR para influir en la narrativa.',
        filterAll: 'Todas',
        filterPress: 'Prensa',
        filterWiki: 'Wiki',
        kindPress: 'Prensa',
        onDomain: 'En el dominio',
        urlsCount: '{{count}} URLs',
        kpi: {
          sources: 'Fuentes',
          sourcesHint: '{{press}} prensa · {{wiki}} wiki',
          citations: 'Citas totales',
          impressions: 'Impresiones / mes',
          coverage: 'Te mencionan',
        },
        cols: {
          source: 'Fuente / URL citada',
          type: 'Tipo',
        },
      },
      forums: {
        platformsTitle: 'Plataformas',
        allPlatforms: 'Todas las plataformas',
        threadCount: '{{count}} hilos',
        allOverview:
          'Mostrando hilos de todas las plataformas. Seleccioná una a la izquierda para enfocarte y ver el detalle.',
        kpi: {
          platforms: 'Plataformas',
          threads: 'Hilos',
          citations: 'Citas totales',
          coverage: 'Hilos que te mencionan',
          impressionsHint: '{{impressions}} impresiones / mes',
          perMonth: 'mensuales',
        },
        cols: {
          platform: 'Plataforma',
          urls: 'URLs distintas',
          thread: 'Hilo',
          topic: 'Tópico',
        },
      },
      external: {
        allPlatforms: 'Todas las plataformas',
        kpi: {
          assets: 'Activos',
          platforms: 'Plataformas',
          citations: 'Citas totales',
          impressionsHint: '{{impressions}} impresiones / mes',
          mentioning: 'Te mencionan',
        },
        cols: {
          platform: 'Plataforma',
          url: 'URL',
          topic: 'Tópico',
        },
      },
      listings: {
        allPlatforms: 'Todas las plataformas',
        allActions: 'Todas las acciones',
        kpi: {
          listings: 'Listings',
          platforms: 'Plataformas',
          citations: 'Citas totales',
          mentioning: 'Te mencionan',
        },
        cols: {
          platform: 'Plataforma',
          url: 'URL',
          pageType: 'Tipo de página',
          category: 'Categoría',
        },
      },
      content: {
        allCompetitors: 'Todos los competidores',
        filterAllTypes: 'Todos los tipos',
        filterEditorial: 'Editorial',
        filterProduct: 'Producto / categoría',
        kpi: {
          opportunities: 'Oportunidades',
          competitors: 'Competidores',
          citations: 'Citas totales',
          impressionsHint: '{{impressions}} impresiones / mes',
          editorial: 'Editorial',
        },
        cols: {
          competitor: 'Competidor',
          url: 'URL citada',
          type: 'Tipo',
          topic: 'Tópico',
          suggestedContent: 'Contenido sugerido para {{brand}}',
        },
      },
    },
  },
} as const
